export const items = [
    {
        id: 1,
        name: 'Coffee cup',
        tag: ['Liquid', 'Plastic', 'Paper', 'Non-recyclable'],
        image: 'https://5.imimg.com/data5/YM/TA/MY-14809086/paper-coffee-cup-500x500.jpg'
    },
    {
        id: 2,
        name: 'Mask',
        tag: ['Non-recyclable'],
        image: 'https://m.media-amazon.com/images/I/61+ilDgVVwS._UL1500_.jpg',
    },
    {
        id: 3,
        name: 'Cigarette butt',
        tag: ['Non-recyclable'],
        image: 'https://therevelator.org/wp-content/uploads/2019/06/cigarette-butt-platt-1.jpg'
    },
    {
        id: 4,
        name: 'Snack bag',
        tag: ['Solid food', 'Plastic'],
        image: 'https://media.istockphoto.com/id/1147024409/photo/after-party-finished-candy-full-of-wrapping-paper.jpg?s=612x612&w=0&k=20&c=ASxDbCSEeWdwkSIW1YWJXerN-eO3BsisTeM3QCeRImA='
    },
    {
        id: 5,
        name: 'Paper',
        tag: ['Paper'],
        image: 'https://img.freepik.com/premium-photo/man-throwing-crumpled-paper-into-trash-can_220873-4510.jpg'
    },
    {
        id: 6,
        name: 'Carton box',
        tag: ['Liquid', 'Non-recyclable'],
        image: 'https://img.uline.com/is/image/uline/c_g9_mobile_NoTxt?$BrowseHD$'
    },
    {
        id: 7,
        name: 'Cans',
        tag: ['Metal'],
        image: 'https://i.guim.co.uk/img/static/sys-images/Guardian/Pix/pictures/2014/10/29/1414600431797/42b241f5-fb55-4ca8-b5e1-37c4bbfe7988-1020x612.jpeg?width=700&quality=85&auto=format&fit=max&s=4bf9eb430e05444241c18e0ce8995e27'
    },
    {
        id: 8,
        name: 'Chewing gum',
        tag: ['Plastic'],
        image: 'https://preview.redd.it/eddukm5bg4k41.jpg?auto=webp&s=fe43a353c51b326f993aaf0b428bcc5615523313'
    },
    {
        id: 9,
        name: 'Napkins',
        tag: ['Paper'],
        image: 'https://www.bigbasket.com/media/uploads/p/l/40017750-3_1-soft-touch-napkin-tissue-eco.jpg'
    },
    {
        id: 10,
        name: 'Clothes',
        tag: ['Fabric'],
        image: 'https://ichef.bbci.co.uk/news/976/cpsprodpb/B426/production/_96581164_mediaitem96575330.jpg'
    },
    {
        id: 10,
        name: 'Battery',
        tag: ['Hazardous chemical'],
        image: 'https://robu.in/wp-content/uploads/2020/07/HW-9V-battery.jpg'
    },
];
